import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { FaSpinner } from "react-icons/fa";

interface PrimaryActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  className?: string;
  size?: "sm" | "default" | "lg";
  icon?: React.ReactNode;
  hoverLight?: boolean;
}

export function PrimaryActionButton({
  children,
  onClick,
  disabled = false,
  isLoading = false,
  loadingText = "Loading...",
  className = "",
  size = "default",
  icon,
  hoverLight = false,
}: PrimaryActionButtonProps) {
  const baseClasses = "bg-white text-black border-0 hover:bg-white/90 disabled:opacity-50 disabled:cursor-not-allowed";
  const hoverLightClasses = hoverLight
    ? "hover:!bg-neutral-300 hover:!text-black hover:!border-neutral-300"
    : "";
  const [hovered, setHovered] = useState(false);
  
  const sizeClasses = {
    sm: "px-4 py-2 text-sm",
    default: "px-6 py-2",
    lg: "px-8 py-3 text-lg"
  };

  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={disabled || isLoading}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={hoverLight && hovered && !(disabled || isLoading)
        ? { backgroundColor: "#d1d5db", color: "#000000", borderColor: "#d1d5db", opacity: 0.5 }
        : undefined}
      className={`${baseClasses} ${hoverLightClasses} ${sizeClasses[size]} flex items-center justify-center gap-2 ${className}`}
    >
      {isLoading ? (
        <>
          <FaSpinner className="animate-spin" />
          {loadingText}
        </>
      ) : (
        <>
          {icon && icon}
          {children}
        </>
      )}
    </Button>
  );
} 